<template>
  <div class="mx-0 px-0">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <b-card
      class=" py-0 my-0 mx-auto col-12 col-xs-12 col-sm-12 col-lg-10 col-md-10 border-0"
    >
      <b-card-title class="mb-4 flex-sm-row">
        <h4 class="pb-4 mb-4">
          <span style="float-left">
            <span class="float-left survey-type-badge btn-primary">
              <fa-icon
                name="clipboard-list"
                size="6x"
              />
            </span>
            <span
              id="set-information"
              class="pl-3 pt-"
            >
              Price Offer
            </span>
          </span>
        </h4>
      </b-card-title>
    </b-card>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
export default {
  name: 'PriceCalculation',
  components: {
    Navbar,
    Breadcrumb
  }
}
</script>
<style>
</style>
